import { GlyphName } from '@remind/r101-glyphs';
import Glyph from 'components/Glyph';
import MediaObject from 'components/MediaObject';
import * as React from 'react';
import Text from 'components/Text';

import './styles/FormNote.scss';

import { GlyphColor } from 'components/Glyph';

type Props = {
  glyph?: GlyphName,
  glyphColor?: GlyphColor,
  children?: React.ReactNode,
};

/**
 * ## Renders supplemental copy in a `form`.
 *
 *
 * ```example
 * <form>
 *   <Field>
 *     <Label htmlFor="input-1">Label</Label>
 *     <Input
 *       id="input-1"
 *       placeholder="Input"
 *     />
 *   </Field>
 *   <Field>
 *     <Label htmlFor="input-2">Label</Label>
 *     <Input
 *       id="input-2"
 *       placeholder="Input"
 *     />
 *   </Field>
 *   <FormNote
 *     glyph="remind-icon"
 *     glyphColor="brand">
 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.
 *   </FormNote>
 * </form>
 * ```
 *
 * ```example
 * <form>
 *   <Field>
 *     <Label htmlFor="input-1">Label</Label>
 *     <Input
 *       id="input-1"
 *       placeholder="Input"
 *     />
 *   </Field>
 *   <Field>
 *     <Label htmlFor="input-2">Label</Label>
 *     <Input
 *       id="input-2"
 *       placeholder="Input"
 *     />
 *   </Field>
 *   <FormNote>
 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.
 *   </FormNote>
 * </form>
 * ```
 *
 *
 * # TODO
 * * Fix `glyph`-less styling or make required
 */

class FormNote extends React.Component<Props> {
  render() {
    const { children, glyphColor } = this.props;
    let glyph;

    if (this.props.glyph) {
      glyph = (
        <Glyph
          name={this.props.glyph}
          color={glyphColor || 'inherit'}
          size="medium"
          className="FormNote-glyph"
        />
      );
    }

    return (
      <MediaObject gutter="small" className="FormNote">
        {glyph}
        <Text size="xxsmall" weight="semibold">
          {children}
        </Text>
      </MediaObject>
    );
  }
}

export default FormNote;
